import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledImageOverlay = styled.div`
  position: fixed;
  z-index: 100;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #0b0b0b;
  opacity: 0.8;
`;

export const StyledImageWrapper = styled.div<{ isSvg: boolean }>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 101;
  box-shadow: 0 0 0.8rem rgba(0, 0, 0, 0.6);
  ${({ isSvg }) => isSvg && 'width: 100%'}
`;

export const StyledImage = styled.img<{ isSvg: boolean }>`
  max-width: 99vw;
  max-height: 92vh;
  object-fit: contain;
  background-color: #444;
  ${({ isSvg }) => isSvg && 'width: 100%'}
`;

export const StyledModalCloseIcon = styled(FontAwesomeIcon)`
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  position: absolute;
  top: -2.6rem;
  right: 0.2rem;
  color: ${({ theme }) => theme.colors.white};
  opacity: 0.6;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
`;
